export default __webpack_public_path__ + "76feb5795a3558db944ae96cc0b93b7a.png";